import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

const makeNoOptionsText = (inputValue: string, t: TFunction<'shared'>): string => {
  // No search term has been entered
  if (inputValue.trim().length === 0) {
    return t('autocomplete.start-typing')
  }
  return t('autocomplete.no-results-for', { searchTerm: inputValue })
}

export const useAutoCompleteConfig = () => {
  const { t } = useTranslation('shared')
  return {
    makeDefaultNoOptionsText: (inputValue?: string) => makeNoOptionsText(inputValue ?? '', t),
  }
}
